import { UUID } from '@okcargo-apps/shared-domain';
export interface ICompanyDocument {
  id: UUID;
  type: EDocumentType;
  name?: string;
  description?: string;
  contentType?: string;
  createdAt?: Date;
  aggregateId?: UUID;
  freightStopId?: UUID;
  companyId?: number;
  path?: string;
  expiresOn?: Date;

  url?: string;
}

export enum EDocumentType {
  TAX_AUTHORITIES_PAYMENT_CERTIFICATE = 'TAX_AUTHORITIES_PAYMENT_CERTIFICATE',
  TAX_AUTHORITIES_PAYMENT_CERTIFICATE_OKCARGO = 'TAX_AUTHORITIES_PAYMENT_CERTIFICATE_OKCARGO',
  SOCIAL_SECURITY_PAYMENT_CERTIFICATE = 'SOCIAL_SECURITY_PAYMENT_CERTIFICATE',
  BANK_OWNERSHIP_CERTIFICATE = 'BANK_OWNERSHIP_CERTIFICATE', //
  GOODS_ASSURANCE = 'GOODS_INSURANCE', //
  EUROPEAN_LICENSE = 'EUROPEAN_LICENSE', //
  CIVIL_RESPONSABILITY_ASSURANCE = 'RLC', //
  ACTIVITY_LICENSE = 'ACTIVITY_LICENSE', // is international
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  FREIGHT_EXPORT = 'FREIGHT_EXPORT',
  EMISSION_JOURNEY = 'EMISSION_JOURNEY',
  DELIVERY_NOTES_EXPORT = 'DELIVERY_NOTES_EXPORT',
  INVOICING_REPORT = 'INVOICING_REPORT',
  FREIGHTS_WITH_ISSUES_REPORT = 'FREIGHTS_WITH_ISSUES_REPORT',
  APAAC_ASSIGNATION_REPORT = 'APAAC_ASSIGNATION_REPORT',
  PAST_DUE_DEBT_INVOICES_REPORT = 'PAST_DUE_DEBT_INVOICES_REPORT',
  ISSUE = 'ISSUE',
  NONE = 'NONE',
}

// TODO move to an specific feature `invoice`

export interface IInvoice {
  id: UUID;
  name: string;
  date: Date;
  dateDue: Date;
  amountTotal: number;
  amountTax: number;
  amountUntaxed: number;
  state: EInvoiceState;
  downloadUrl: EInvoiceState;
}

// TODO remove this, use EInvoiceStatus??
export enum EInvoiceState {
  NOT_PAID = 'NOT_PAID',
  IN_PAYMENT = 'IN_PAYMENT',
  PAID = 'PAID',
  DRAFT = 'DRAFT',
  GENERATED = 'GENERATED',
}

export enum EInvoiceType {
  PURCHASE = 'PURCHASE',
  SALE = 'SALE',
}
